module.exports = __webpack_public_path__ + "static/soc2-d8698701ccaf7a7823c516b185d23bbb.png";